export enum EGiftListItemType {
  RadioButton,
  CheckBox,
}
